import { Users } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useFamilyScope } from "../../context/FamilyScopeContext";

const FIELD_CLASS =
  "cursor-pointer bg-transparent text-xs font-bold text-slate-800 focus-visible:outline-2 focus-visible:outline-wicend-500 focus-visible:outline-offset-2 dark:text-slate-200";
const OPTION_CLASS = "bg-white text-slate-800 dark:bg-slate-900 dark:text-slate-200";

export function FamilyChildSwitcher() {
  const { activePersona } = useAuth();
  const { childrenList, activeChildId, setActiveChildId } = useFamilyScope();

  const isFamily = activePersona === "PARENT";

  if (!isFamily || childrenList.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-slate-50 px-2.5 py-1.5 dark:border-slate-800 dark:bg-slate-900 max-w-[140px] sm:max-w-[200px]">
        <Users size={16} className="shrink-0 text-emerald-600 dark:text-emerald-400" />
        <select
          value={activeChildId ?? ""}
          onChange={(e) => setActiveChildId(e.target.value)}
          className={`${FIELD_CLASS} truncate`}
          aria-label="Pilih anak"
          data-testid="shell-child-switcher-select"
        >
          {childrenList.map((child) => (
            <option key={child.id} value={child.id} className={OPTION_CLASS}>
              {child.fullName}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
